import DashboardViewer from 'components/dashboard/DashboardViewer';

const DashboardPage = () => {
  return <DashboardViewer />;
};

export default DashboardPage;
